export default __webpack_public_path__ + "static/media/assignedVehicles.0c4830d9.svg";